import React, {useState} from "react";
import {Form, Input, Modal, Switch} from "antd";
import {useTranslation} from "react-i18next";
import {useStore} from "hooks/useStore";
import {TICKET_MAX_NOTE_LENGTH} from "constants/ticket";
import {isOwnerNoteVisibilityLocked} from "../common/ticketUtils";

export const CloseTicketModal = ({ticket, visible, onCancel, onClosed}) => {
    const {t} = useTranslation(["tickets"]);
    const stores = useStore();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const isLocked = isOwnerNoteVisibilityLocked(ticket);

    const handleSubmit = async () => {
        let values;
        try {
            values = await form.validateFields();
        } catch (error) {
            return;
        }
        setLoading(true);
        const result = await stores.ticketStore.closeTicket(ticket._id, {
            note: values.note.trim(),
            isNoteShownToOwner: !isLocked && Boolean(values.isNoteShownToOwner)
        });
        setLoading(false);
        if (result) {
            form.resetFields();
            onClosed();
        }
    };

    return (
        <Modal
            title={t("detail.closeModal.title", {ns: "tickets"})}
            visible={visible}
            onOk={handleSubmit}
            onCancel={onCancel}
            confirmLoading={loading}
            okText={t("detail.closeModal.confirm", {ns: "tickets"})}
            cancelText={t("detail.closeModal.cancel", {ns: "tickets"})}
            destroyOnClose
        >
            <Form form={form} layout="vertical" initialValues={{isNoteShownToOwner: false}}>
                <Form.Item
                    label={t("detail.closeModal.note", {ns: "tickets"})}
                    name="note"
                    rules={[
                        {
                            required: true,
                            whitespace: true,
                            message: t("detail.closeModal.noteRequired", {ns: "tickets"})
                        }
                    ]}
                >
                    <Input.TextArea
                        rows={4}
                        maxLength={TICKET_MAX_NOTE_LENGTH}
                        placeholder={t("detail.closeModal.notePlaceholder", {ns: "tickets"})}
                    />
                </Form.Item>
                <Form.Item
                    label={t("detail.closeModal.showToOwner", {ns: "tickets"})}
                    name="isNoteShownToOwner"
                    valuePropName="checked"
                    style={{marginBottom: 0}}
                >
                    <Switch disabled={isLocked} />
                </Form.Item>
            </Form>
        </Modal>
    );
};
